// extracted by mini-css-extract-plugin
export default {"title":"module_title__QiqJA","module":"module_module__-wh7M","loader":"module_loader__HykQ6"};